module.exports = __webpack_public_path__ + "images/3-hover5cac1e8cbd4f28ad36cecb5886da79f8.svg";